import { memo } from 'react';
import Image from 'next/image';
import settings from '@/settings';
import fbIcon from '@/public/icons/marketing/facebook.svg';
import igIcon from '@/public/icons/marketing/instagram.svg';
import youtubeIcon from '@/public/icons/marketing/youtube.svg';
import tiktokIcon from '@/public/icons/marketing/tiktok.svg';
import linkedinIcon from '@/public/icons/marketing/linkedin.svg';

const SOCIALS = [
  {
    href: settings.marketing.tiktok_url,
    icon: tiktokIcon,
    alt: 'TikTok',
    w: 17,
    h: 17,
  },
  {
    href: settings.marketing.youtube_url,
    icon: youtubeIcon,
    alt: 'YouTube',
    w: 22,
    h: 20,
  },
  {
    href: settings.marketing.facebook_url,
    icon: fbIcon,
    alt: 'Facebook',
    w: 17,
    h: 17,
  },
  {
    href: settings.marketing.instagram_url,
    icon: igIcon,
    alt: 'Instagram',
    w: 17,
    h: 17,
  },
  {
    href: settings.marketing.linkedin_url,
    icon: linkedinIcon,
    alt: 'LinkedIn',
    w: 17,
    h: 17,
  },
] as const;

const Socials = memo(() => (
  <div className="flex justify-center gap-6 sm:gap-8 md:gap-10 lg:gap-12">
    {SOCIALS.filter(({ href }) => !!href).map(({ href, icon, alt, w, h }) => (
      <a
        key={alt}
        className="hover:text-teal-500"
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        {/* eslint-disable-next-line react/forbid-dom-props */}
        <span className="inline-block" style={{ width: w, height: h }}>
          <Image
            src={icon}
            alt={alt}
            width={w}
            height={h}
            sizes={`${w}px`}
            loading="lazy"
            className="h-full w-full object-contain"
          />
        </span>
      </a>
    ))}
  </div>
));

export default Socials;
